/* =================================================================
   HIJOS DEL VIENTO — Tema Shopify · theme.js
   Navbar, menú móvil, carrito AJAX con drawer, animaciones reveal.
   ================================================================= */
(function () {
  "use strict";
  var HDV = window.HDV || {};
  // Prefijo de rutas (respeta dominios con /es/ etc.)
  var base = (HDV.cartUrl || "/cart").replace(/\/cart$/, "");
  var EP = {
    cart: base + "/cart.js",
    add: base + "/cart/add.js",
    change: base + "/cart/change.js",
    checkout: base + "/checkout",
    cartPage: base + "/cart",
  };

  var MXN = new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", minimumFractionDigits: 0 });
  var money = function (cents) { return MXN.format((cents || 0) / 100); };

  /* ---------- Navbar ---------- */
  var nav = document.getElementById("nav");
  if (nav) {
    var onScroll = function () { nav.classList.toggle("scrolled", window.scrollY > 20); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }
  var burger = document.getElementById("burger");
  var menu = document.getElementById("mobile-menu");
  if (burger && menu) {
    burger.addEventListener("click", function () {
      var open = menu.classList.toggle("open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    menu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () { menu.classList.remove("open"); });
    });
  }

  /* ---------- Drawer abrir/cerrar ---------- */
  var overlay = document.getElementById("cart-overlay");
  var drawer = document.getElementById("cart-drawer");
  function openCart() { if (overlay && drawer) { overlay.classList.add("open"); drawer.classList.add("open"); document.body.style.overflow = "hidden"; } }
  function closeCart() { if (overlay && drawer) { overlay.classList.remove("open"); drawer.classList.remove("open"); document.body.style.overflow = ""; } }
  window.HDVopenCart = openCart;

  var openBtn = document.getElementById("open-cart");
  if (openBtn) openBtn.addEventListener("click", function (e) { e.preventDefault(); openCart(); renderCart(); });
  var closeBtn = document.getElementById("close-cart");
  if (closeBtn) closeBtn.addEventListener("click", closeCart);
  if (overlay) overlay.addEventListener("click", closeCart);

  /* ---------- Contador ---------- */
  function setCount(n) {
    document.querySelectorAll("#cart-count").forEach(function (el) { el.textContent = n; el.dataset.count = n; });
  }

  /* ---------- Render carrito ---------- */
  function renderCart() {
    var items = document.getElementById("cart-items");
    var foot = document.getElementById("cart-foot");
    if (!items) return;
    fetch(EP.cart, { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        if (!cart.items || cart.items.length === 0) {
          items.innerHTML =
            '<div class="cart-empty"><p style="font-size:1.05rem;margin-bottom:8px">Tu carrito está vacío.</p>' +
            '<p style="font-size:.9rem">Es hora de sumar kilómetros.</p>' +
            '<a href="' + EP.cartPage.replace("/cart", "/collections/all") + '" class="btn btn--primary mt-2">Ver colección</a></div>';
          foot.innerHTML = "";
          return;
        }
        items.innerHTML = cart.items.map(function (i) {
          var img = i.image ? '<img src="' + i.image.replace(/(\.[^.]+)(\?.*)?$/, "_120x150$1") + '" alt="' + escapeHtml(i.product_title) + '">' : '<div style="width:64px;height:80px;background:var(--surface-2);border-radius:8px"></div>';
          var variant = (i.variant_title && i.variant_title !== "Default Title") ? '<div class="cart-item__meta">' + escapeHtml(i.variant_title) + "</div>" : "";
          return '<div class="cart-item">' + img +
            '<div><div class="cart-item__name">' + escapeHtml(i.product_title) + "</div>" + variant +
            '<div class="qty"><button data-key="' + i.key + '" data-q="' + (i.quantity - 1) + '" aria-label="Menos">−</button>' +
            "<span>" + i.quantity + "</span>" +
            '<button data-key="' + i.key + '" data-q="' + (i.quantity + 1) + '" aria-label="Más">+</button></div>' +
            '<a class="cart-item__remove" data-key="' + i.key + '" data-q="0">Eliminar</a></div>' +
            '<div class="cart-item__price">' + money(i.final_line_price) + "</div></div>";
        }).join("");
        foot.innerHTML =
          '<div class="cart-total"><span>Subtotal</span><span>' + money(cart.total_price) + "</span></div>" +
          '<a href="' + EP.checkout + '" class="btn btn--primary btn--block btn--lg">Pagar ahora</a>' +
          '<a href="' + EP.cartPage + '" class="btn btn--ghost btn--block">Ver carrito</a>' +
          '<p class="cart-note">Envío e impuestos calculados en el checkout · Pago seguro</p>';

        items.querySelectorAll(".qty button, .cart-item__remove").forEach(function (b) {
          b.addEventListener("click", function () { changeLine(b.dataset.key, parseInt(b.dataset.q, 10)); });
        });
      })
      .catch(function () { items.innerHTML = '<div class="cart-empty"><a href="' + EP.cartPage + '" class="btn btn--primary">Ver carrito</a></div>'; });
  }

  function changeLine(key, qty) {
    fetch(EP.change, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    }).then(function () { renderCart(); });
  }

  /* ---------- Agregar al carrito (AJAX) ---------- */
  function bindAddForms() {
    document.querySelectorAll("form.js-add-form, form[action$='/cart/add']").forEach(function (form) {
      if (form.__bound) return;
      form.__bound = true;
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector("[type=submit]");
        var original = btn ? btn.textContent : "";
        if (btn) { btn.disabled = true; btn.textContent = "Agregando…"; }
        fetch(EP.add, { method: "POST", headers: { "Accept": "application/json" }, body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { // error
              if (btn) { btn.textContent = res.description || "No disponible"; }
              setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1800);
              return;
            }
            renderCart();
            openCart();
            if (btn) { btn.disabled = false; btn.textContent = original; }
          })
          .catch(function () { form.submit(); }); // respaldo sin JS
      });
    });
  }
  bindAddForms();

  /* ---------- Animación reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".reveal:not(.in)");
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("in"); }); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); obs.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { obs.observe(e); });
  }
  initReveal();

  function escapeHtml(s) { return (s || "").replace(/[&<>"']/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]; }); }

  // Re-vincular tras cambios del editor de temas (Shopify)
  document.addEventListener("shopify:section:load", function () { bindAddForms(); initReveal(); });
})();
